<template>
  <div>
    <section>
      <TippCard
        hintID="Terminplanung_Konfiguration_Allgemein_1_V1"
        text="Um das Erstellen von Veranstaltungen zu erleichtern, kannst Du diese aus Vorlagen heraus erstellen. Lege dafür die gewünschten Werte im Vorfeld fest und speichere diese als Vorlage ab. Beim Anlegen einer Veranstaltung kannst Du nun die bereits eingegeben Daten schnell und unkompliziert übernehmen."
      >
      </TippCard>
    </section>
    <section>
      <template>
        <v-container>
          <v-row justify="center" align="center">
            <v-col cols="12">
              <Subheader
                icon="mdi-book"
                title="Vorlagen"
                :actions="actions"
              ></Subheader>
              <div class="mt-7">
                <v-data-table
                  :headers="headers"
                  :items="templates"
                  :sort-by="sortBy"
                  :sort-desc="sortDesc"
                  no-data-text="Keine Vorlagen vorhanden"
                  item-key="meta.id"
                  class="elevation-2"
                  :items-per-page="15"
                  :footer-props="footerProps"
                  single-expand
                  show-expand
                  :expanded.sync="expanded"
                >
                  <template v-slot:[`item.template.title`]="{ item }">
                    <div class="d-flex flex-column">
                      {{ item.template.title }}
                      <small class="grey--text">
                        <span>{{ item.template.description }} </span>
                      </small>
                    </div>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                      <v-card-text>
                        <v-row dense>
                          <v-col cols="12">
                            <h3>{{ item.data.title }}</h3>
                          </v-col>
                          <v-col
                            cols="12"
                            v-if="item.data.type && item.data.type.id"
                          >
                            <data-chip
                              small
                              :color="item.data.type.color"
                              :text="item.data.type.title"
                            >
                            </data-chip>
                          </v-col>
                          <v-col cols="12">
                            <v-icon dense>mdi-calendar-clock</v-icon>
                            <span class="ml-2"
                              >{{ item.data.duration.start.time }} Uhr bis
                              {{ item.data.duration.end.time }} Uhr
                            </span>
                            <span
                              class="ml-3 error--text"
                              v-if="
                                item.data.duration.start.isOpen &&
                                !item.data.duration.end.isOpen
                              "
                              >Startzeit offen</span
                            >
                            <span
                              class="ml-3 error--text"
                              v-if="
                                !item.data.duration.start.isOpen &&
                                item.data.duration.end.isOpen
                              "
                              >Endzeit offen</span
                            >
                            <span
                              class="ml-3 error--text"
                              v-if="
                                item.data.duration.start.isOpen &&
                                item.data.duration.end.isOpen
                              "
                              >Start- und Endzeit offen</span
                            >
                          </v-col>
                          <v-col
                            cols="12"
                            v-if="item.data.location && item.data.location.name"
                          >
                            <v-icon dense>mdi-map-marker</v-icon>
                            <span class="ml-2">{{
                              item.data.location.name
                            }}</span>
                          </v-col>
                          <v-col cols="12" v-if="item.data.description">
                            <v-icon dense>mdi-calendar-text</v-icon>
                            <span class="ml-2">{{
                              item.data.description
                            }}</span>
                          </v-col>
                          <v-col
                            cols="12"
                            v-if="
                              item.data.config &&
                              item.data.config.organizer &&
                              item.data.config.organizer.isAppointed
                            "
                          >
                            <v-icon dense>mdi-account-hard-hat</v-icon>
                            <span class="ml-2"
                              >Organisation:
                              {{ item.data.config.organizer.description }}</span
                            >
                          </v-col>
                          <v-col
                            cols="12"
                            v-if="
                              item.data.config &&
                              item.data.config.attendance &&
                              item.data.config.attendance.isLimited
                            "
                          >
                            <v-icon dense>mdi-account-multiple-check</v-icon>
                            <span class="ml-2"
                              >Teilnahmebeschränkung:
                              {{
                                item.data.config.attendance.description
                              }}</span
                            >
                            <v-chip
                              v-for="division in item.data.config.attendance
                                .allowedDivisions || []"
                              :key="division.id"
                              label
                              small
                              class="ml-2 my-1"
                            >
                              <v-icon small left>mdi-home-group</v-icon
                              >{{ division.title }}
                            </v-chip>
                            <v-chip
                              v-for="group in item.data.config.attendance
                                .allowedUserGroups || []"
                              :key="group.id"
                              label
                              small
                              class="ml-2 my-1"
                            >
                              <v-icon small left>mdi-folder-account</v-icon
                              >{{ group.title }}
                            </v-chip>
                            <v-chip
                              v-for="person in item.data.config.attendance
                                .allowedPersons || []"
                              :key="person.uid"
                              label
                              small
                              class="ml-2 my-1"
                            >
                              <v-icon small left>mdi-account-circle</v-icon
                              >{{ person.displayName }}
                            </v-chip>
                          </v-col>
                          <v-col
                            cols="12"
                            v-if="
                              item.data.config &&
                              (item.data.config.responses.deadline.isCustom ||
                                item.data.config.attendance.isMandatory ||
                                item.data.config.responses.areBinding ||
                                item.data.config.responses.areLocked)
                            "
                          >
                            <v-chip
                              label
                              v-if="
                                item.data.config.responses.deadline.isCustom
                              "
                              class="mr-2 my-1"
                            >
                              Rückmeldung
                              {{
                                item.data.config.responses.deadline.inMinutes
                              }}
                              Minuten vor Beginn
                            </v-chip>
                            <v-chip
                              label
                              v-if="item.data.config.attendance.isMandatory"
                              class="mr-2 my-1"
                            >
                              <v-icon small left>mdi-alert-circle</v-icon
                              >Anwesenheitspflicht
                            </v-chip>
                            <v-chip
                              label
                              v-if="item.data.config.responses.areBinding"
                              class="mr-2 my-1"
                            >
                              <v-icon small left>mdi-check-decagram</v-icon
                              >Rückmeldungen verbindlich
                            </v-chip>
                            <v-chip
                              label
                              v-if="item.data.config.responses.areLocked"
                              class="mr-2 my-1"
                            >
                              <v-icon small left>mdi-lock</v-icon>Rückmeldungen
                              gesperrt
                            </v-chip>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-actions class="px-4 pt-0 mt-n2 mb-2">
                        <v-btn
                          text
                          outlined
                          class="mr-2"
                          @click="editItem(item)"
                        >
                          <v-icon left small>mdi-pencil</v-icon>Bearbeiten
                        </v-btn>
                        <v-btn
                          text
                          outlined
                          color="error"
                          @click="deleteItem(item)"
                        >
                          <v-icon left small>mdi-trash-can</v-icon>Löschen
                        </v-btn>
                      </v-card-actions>
                    </td>
                  </template>
                </v-data-table>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>
    <router-view />
  </div>
</template>

<script>
import TippCard from "@/components/_systemwide/Tipp_Card.vue";
import DataChip from "@/components/_systemwide/DataChip.vue";
import Subheader from "@/components/_systemwide/Subheader.vue";
import { SCHEDULING } from "@/store/modules.js";
import {
  GET_EVENT_TEMPLATES,
  DELETE_EVENT_TEMPLATE,
} from "@/store/action-types.js";
import { SCHEDULING_CONFIG_EVENT_TEMPLATES_create } from "@/data/permission-types.js";

export default {
  name: "scheduling-config-tab-templates",
  components: {
    TippCard,
    Subheader,
    DataChip,
  },
  data() {
    return {
      sortDesc: false,
      sortBy: "template.sortKey",
      footerProps: {
        "items-per-page-options": [15, 25, 50, -1],
      },
      headers: [
        {
          text: "Bezeichnung",
          value: "template.title",
          align: "start",
        },
        {
          text: "Sortierschlüssel",
          value: "template.sortKey",
        },
        { text: "", value: "data-table-expand", width: "1%" },
      ],
      expanded: [],
      actions: [
        {
          title: "Erstellen",
          icon: "mdi-playlist-plus",
          permission: `${SCHEDULING_CONFIG_EVENT_TEMPLATES_create}`,
          actionStyle: "textBtn",
          function: this.vorlageErstellen,
        },
      ],
    };
  },
  computed: {
    templates() {
      return this.$store.state.scheduling.eventTemplates;
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.$store.dispatch(`${SCHEDULING}${GET_EVENT_TEMPLATES}`, {
        organizationId: this.$route.params.organizationId,
      });
    },
    vorlageErstellen() {
      this.$router.push({
        name: "scheduling-config-tab-templates-template-new",
      });
    },
    editItem(item) {
      this.$router.push({
        name: "scheduling-config-tab-templates-template-edit",
        params: {
          organizationId: this.$route.params.organizationId,
          itemId: item.meta.id,
        },
      });
    },
    deleteItem(item) {
      var res = confirm(
        "Bist Du sicher, dass Du diese Vorlage löschen möchtest?"
      );
      if (res == true) {
        this.$store.dispatch(`${SCHEDULING}${DELETE_EVENT_TEMPLATE}`, {
          organizationId: this.$route.params.organizationId,
          itemId: item.meta.id,
        });
      }
    },
  },
};
</script>
